import { render, staticRenderFns } from "./StarInfo.vue?vue&type=template&id=763bebda&scoped=true&"
import script from "./StarInfo.vue?vue&type=script&lang=js&"
export * from "./StarInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763bebda",
  null
  
)

export default component.exports